/* Fix My Posture Bundle: Buy it now asks for a required size first, as Add to
   cart does.

   The lower buy box carries a required Custom property block, "Functional
   Activator Size". The theme's Add to cart will not add while it is empty: it
   shows that property's own "This field is required" line and moves focus to it
   (component-product-form.js, ProductForm.onSubmitHandler). Shopify's payment
   buttons never run that check, so Buy it now went straight to checkout with no
   Activator Size (copy preview, 2026-10-08).

   A click on a payment button is therefore checked first, in the capture phase
   on window, before Shopify's own handler. If that button's product form still
   has an empty required Custom property, the click is stopped and the theme's
   message is shown exactly as Add to cart shows it. With a size chosen, the
   click passes untouched and Shopify sends the size with the order (its
   cartCreate request carries "Functional Activator Size").

   The check is on the payment button container, so it covers whatever Shopify
   draws there: Buy it now, Google Pay, Shop Pay, More payment options. Only the
   theme's own Custom property blocks tied to that same form are read, so the top
   box, where SC Product Options checks its own dropdown, is never involved.
   Nothing is hidden or disabled, and no form, variant, quantity, cart or
   checkout is written.

   Loaded on the Fix My Posture Bundle template only, by its section
   fmp_required_size. */
(function () {
  'use strict';

  if (window.fmpRequiredSizeLoaded) { return; }
  window.fmpRequiredSizeLoaded = true;

  function emptyRequired(form) {
    var component = form.closest('[data-js-product-component]');
    if (!component) { return null; }
    var props = component.querySelectorAll('[data-js-custom-property]');
    for (var i = 0; i < props.length; i++) {
      var field = props[i].querySelector('[required]');
      if (!field || field.form !== form) { continue; }
      if (field.type === 'checkbox' ? !field.checked : field.value === '') {
        return { prop: props[i], field: field };
      }
    }
    return null;
  }

  function askForRequired(e) {
    var button = e.target && e.target.closest ? e.target.closest('.shopify-payment-button') : null;
    var form = button && button.closest('form');
    var missing = form && emptyRequired(form);
    if (!missing) { return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    var message = missing.prop.querySelector('.' + (window.KT_PREFIX || '') + 'product-variant__required');
    if (message) {
      message.style.display = 'block';
      if (!missing.prop.hasAttribute('data-fmp-required-watched')) {
        missing.prop.setAttribute('data-fmp-required-watched', '');
        var hide = function () { message.style.display = 'none'; };
        missing.prop.addEventListener('click', hide);
        missing.field.addEventListener('change', hide);
      }
    }
    missing.field.focus();
  }

  window.addEventListener('click', askForRequired, true);
})();
